<div class="wrapper" *ngIf="show">
    <div class="wrapper-body">
        <div class="container-fluid">
            <div class="row" *ngIf="apptDetails">
                <div class="col-12">
                    <div class="page-header align-items-lg-center d-flex flex-column flex-md-row">
                        <h3>{{apptDetails.parentDetails.studentFirstName}} {{apptDetails.parentDetails.studentLastName}}
                            Details</h3>
                        <a *ngIf='(userRole=="ADMIN") && (!followUpCreated) && (apptDetails.appointmentDetails.schedules[0].status!="ASSESMENT" || apptDetails.appointmentDetails.schedules[0].status!="COMPLETE" )'
                            class="ml-auto theme-button m-2" (click)="openFollowUpModal()">
                            Create Follow Up
                        </a>
                        <a *ngIf="
                            apptDetails.appointmentDetails.schedules[0].backgroundFormStatus==true && apptDetails.parentDetails.grade!='Adult' && apptDetails.parentDetails.grade!='College'"
                            [routerLink]="['/admin-background-form',apptDetails.appointmentDetails.appointmentId]"
                            target="_blank" class="ml-auto theme-button green">
                            View Background Form
                        </a>

                        <a *ngIf="
                            apptDetails.appointmentDetails.schedules[0].backgroundFormStatus==true && (apptDetails.parentDetails.grade=='Adult' || apptDetails.parentDetails.grade=='College')"
                            [routerLink]="['/admin-background-form-adult',apptDetails.appointmentDetails.appointmentId]"
                            target="_blank" class="ml-auto theme-button green">
                            View Background Form
                        </a>
                        <a *ngIf="apptDetails.appointmentDetails.schedules[0].status=='ASSESMENT' || apptDetails.appointmentDetails.schedules[0].status=='COMPLETE'"
                            [routerLink]="['/view-student-observation',apptDetails.appointmentDetails.appointmentId]"
                            class="theme-button green ml-2">View Student Observation</a>

                        <a *ngIf="documents.length>0" href="javascript:Void(0)" data-target="#viewDocumentsModal"
                            data-toggle="modal" class=" ml-2 theme-button green">View Documents</a>


                    </div>
                </div>

                <!-- Alerts -->
                <div class="col-12">
                    <div class="card"
                        *ngIf="apptDetails.appointmentDetails.schedules.length<=1 && apptDetails.appointmentDetails.schedules[0].status!='ASSESMENT' && apptDetails.appointmentDetails.schedules[0].status!='COMPLETE'">
                        <p class="m-0 alert alert-warning">
                            Follow up is not scheduled.
                        </p>
                    </div>
                    <div class="card" *ngIf="apptDetails.appointmentDetails.schedules[0].backgroundFormStatus==false">
                        <p class="m-0 alert alert-warning">
                            Background Form Not Submitted.
                        </p>
                    </div>
                    <div class="card"
                        *ngIf='!apptDetails.appointmentDetails.schedules[0].statusTracking.includes("REVIEWED") || apptDetails.appointmentDetails.schedules[0].status=="CREATED"'>
                        <p class="m-0 alert alert-warning">
                            Test plans are not selected.
                        </p>
                    </div>
                    <div class="card" *ngIf="apptDetails.appointmentDetails.schedules[0].status=='ASSESMENT'">
                        <p class="m-0 alert alert-info">
                            Test is Completed.
                        </p>
                    </div>
                    <!-- <div class="card"
                        *ngIf="apptDetails.appointmentDetails.schedules[0].status!='COMPLETE' && status=='FOLLOWUP'">
                        <p class="m-0 alert alert-info">
                            Follow Up Scheduled
                        </p>
                    </div> -->
                    <div class="card" *ngIf="apptDetails.appointmentDetails.schedules[0].status=='CANCEL'">
                        <p class="m-0 alert alert-danger">
                            Appointment is Canceled
                        </p>
                    </div>
                </div>

                <!-- Appoitment Detail -->
                <div class="col-12">
                    <div class="card">

                        <h5 class="mb-0 text-purple">Appointment Details <a
                                *ngIf='(userRole=="ADMIN") && apptDetails.appointmentDetails.schedules[0].status!="ASSESMENT" && apptDetails.appointmentDetails.schedules[0].status!="CANCEL" && apptDetails.appointmentDetails.schedules[0].status!="COMPLETE"'
                                [routerLink]="['/reschedule-appointments', apptId]"
                                class="ml-auto px-3 py-2 badge bg-purple text-white float-md-right">Reschedule
                                Appointment</a>
                            <a *ngIf='(userRole=="ADMIN") && apptDetails.appointmentDetails.schedules[0].status!="ASSESMENT" && apptDetails.appointmentDetails.schedules[0].status!="CANCEL" && apptDetails.appointmentDetails.schedules[0].status!="COMPLETE"'
                                [routerLink]="['/re-assign', apptId]"
                                class="ml-auto mr-3 px-3 py-2 badge bg-purple text-white float-md-right">Re-assign
                                Appointment</a>
                            <a *ngIf='(userRole=="ADMIN") && apptDetails.appointmentDetails.schedules[0].status!="ASSESMENT" && apptDetails.appointmentDetails.schedules[0].status!="CANCEL" && apptDetails.appointmentDetails.schedules[0].status!="COMPLETE"'
                                href="javascript:void(0)" data-toggle="modal" data-target="#editAssementType"
                                class="ml-auto mr-3 px-3 py-2 badge bg-purple text-white float-md-right"
                                (click)="getAssementType()">Edit Assessment Type</a>
                        </h5>
                        <hr>
                        <div class="row">
                            <div class="col-md-4">
                                <label class="text-grey"> Date</label>
                                <p> {{apptDetails.appointmentDetails.schedules[0].appointmentDate}}</p>
                            </div>
                            <div class="col-md-4">
                                <label class="text-grey">Time</label>
                                <p> {{apptDetails.appointmentDetails.schedules[0].appointmentTime}}</p>
                            </div>
                            <div class="col-md-4">
                                <label class="text-grey">Location</label>
                                <p> {{apptDetails.appointmentDetails.location}}</p>
                            </div>
                            <div class="col-md-4">
                                <label class="text-grey">Diagnostician</label>
                                <p> {{apptDetails.appointmentDetails.diagnosticianName}}</p>
                            </div>
                            <div class="col-md-4">
                                <label class="text-grey">Assessment Type</label>
                                <p> {{apptDetails.appointmentDetails.assesmentType}}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Follow up Details  -->
                <div class="col-12" *ngIf='status=="FOLLOWUP"'>
                    <div class="card">
                        <h5 class="mb-0 text-purple">Follow Up Details <a *ngIf='(userRole=="ADMIN")'
                                [routerLink]="['/reschedule-follow-up', apptId]"
                                class="ml-auto px-3 py-2 badge bg-purple text-white float-md-right">Reschedule Follow
                                Up</a></h5>
                        <hr>
                        <div class="row">
                            <div class="col-md-4">
                                <label class="text-grey"> Date</label>
                                <p> {{followUpDetails.appointmentDate}}</p>
                            </div>
                            <div class="col-md-4">
                                <label class="text-grey">Time</label>
                                <p> {{followUpDetails.appointmentTime}}</p>
                            </div>

                            <div class="col-md-4">
                                <label class="text-grey">Assigned To</label>
                                <p> {{followUpDetails.adminName}}</p>
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <label class="text-grey">Follow Up Type</label>
                                <p>  {{getMeetingType(followUpDetails.meetingType)}}</p>
                            </div>
                        </div>

                        

                    </div>
                </div>

                <!-- Survey Detail -->
                <div *ngIf="apptDetails.appointmentDetails.schedules[0].statusTracking.includes('REVIEWED') && apptDetails.appointmentDetails.schedules[0].assesmentSurvey"
                    class="col-md-6">
                    <div class="card">
                        <h5 class="mb-0 text-purple">Surveys to be performed</h5>
                        <hr>
                        <div class="row">
                            <div class="col-12">
                                <div class="d-flex flex-wrap">
                                    <p class="badge badge-pill bg-purple-light mr-2  px-3 py-2"
                                        *ngFor="let survey of apptDetails.appointmentDetails.schedules[0].assesmentSurvey">
                                        {{survey.name}}</p>
                                </div>
                                <div class="d-flex flex-wrap"
                                    *ngIf="apptDetails.appointmentDetails.schedules[0].assesmentSurvey.length==0">
                                    <p class="text-warning mb-0">
                                        No Surveys</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Test Detial -->
                <div *ngIf="apptDetails.appointmentDetails.schedules[0].statusTracking.includes('REVIEWED') && apptDetails.appointmentDetails.schedules[0].assesmentTest"
                    class="col-md-6">
                    <div class="card">
                        <h5 class="mb-0 text-purple">Tests to be performed</h5>
                        <hr>
                        <div class="row">
                            <div class="col-12">
                                <div class="d-flex flex-wrap">
                                    <p class="badge badge-pill bg-purple-light mr-2 px-3 py-2"
                                        *ngFor="let test of apptDetails.appointmentDetails.schedules[0].assesmentTest">
                                        {{test.name}}
                                    </p>
                                </div>
                                <div class="d-flex flex-wrap"
                                    *ngIf="apptDetails.appointmentDetails.schedules[0].assesmentTest.length==0">
                                    <p class="text-warning mb-0">
                                        No Tests</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Test Notes -->
                <div *ngIf="testSurveyComment.length>0" class="col-md-12">
                    <div class="card">
                        <h5 class="mb-0 text-purple">Testing Notes</h5>
                        <hr>
                        <div class="row">
                            <div class="col-12">

                                <textarea name="testSurveyComment" [(ngModel)]="testSurveyComment" readonly="trues"
                                    rows="4" class="custom-input" placeholder="Other Comments"></textarea>

                            </div>
                        </div>
                    </div>
                </div>

                <!-- Client Details -->
                <div class="col-12">
                    <div class="card">
                        <h5 class="mb-0 text-purple">Client Details <a *ngIf='(userRole=="ADMIN")'
                                href="javascript:void(0)" data-toggle="modal" data-target="#editClientInfo"
                                class="ml-auto px-3 py-2 badge bg-purple text-white float-md-right"
                                (click)="updateClientMethod()">Edit Client</a></h5>
                        <hr>
                        <div class="row">
                            <div class="col-md-4">
                                <label class="text-grey">Full Name</label>
                                <p> {{appts.studentFirstName}}
                                    {{appts.studentLastName}} </p>
                            </div>
                            <div class="col-md-4">
                                <label class="text-grey">Parent Name</label>

                                <p> {{appts.parentName}}</p>
                            </div>

                            <div class="col-md-4">
                                <label class="text-grey">Date Of Birth</label>
                                <p> {{appts.dateOfBirth|date :'MM/dd/yyyy'}}</p>
                            </div>

                            <div class="col-md-4">
                                <label class="text-grey">Phone Number</label>
                                <p> {{appts.phoneNumber}}</p>
                            </div>
                            <div class="col-md-4">
                                <label class="text-grey">Cell Number</label>

                                <p> {{appts.cellNumber}}</p>
                            </div>
                            <div class="col-md-4">
                                <label class="text-grey">Email </label>
                                <p> {{appts.emailAddress}}</p>
                            </div>
                            <div class="col-md-4">
                                <label class="text-grey">Secondary Email</label>

                                <p> {{appts.secondaryEmailAddress}}</p>
                            </div>
                            <div class="col-md-4">
                                <label class="text-grey">Grade</label>
                                <p> {{appts.grade}}</p>
                            </div>
                            <div class="col-md-4">
                                <label class="text-grey">School Type</label>
                                <p> {{appts.schoolType}}</p>
                            </div>
                            <div class="col-md-4">
                                <label class="text-grey">School/District</label>
                                <p> {{appts.school}}</p>
                            </div>
                            <div class="col-md-4">
                                <label class="text-grey">Reason For Call</label>
                                <p> {{appts.reasonForCall}}</p>
                            </div>
                            <div class="col-md-4">
                                <label class="text-grey">Address1</label>
                                <p> {{appts.address1}}</p>
                            </div>
                            <div class="col-md-4">
                                <label class="text-grey">Address2</label>
                                <p> {{appts.address2}}</p>
                            </div>
                            <div class="col-md-4">
                                <label class="text-grey">City</label>
                                <p> {{appts.city}}</p>
                            </div>
                            <div class="col-md-4">
                                <label class="text-grey">State</label>
                                <p> {{appts.state}}</p>
                            </div>
                            <div class="col-md-4">
                                <label class="text-grey">Zip Code</label>
                                <p> {{appts.zipCode}}</p>
                            </div>
                            <div class="col-md-4">
                                <label class="text-grey">Additional Comments</label>

                                <p> {{appointmentComments}}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Notes -->
                <div class="col-12" >
                    <div class="card">
                        <h5 class="mb-0 text-purple">Notes 

                            <a *ngIf='(userRole=="ADMIN") || (userRole=="DIRECTOR")'
                            href="javascript:void(0)" (click)="openAddNotesModeal(appNotesDetails)" data-toggle="modal" data-target="#addNotesModal"
                            class="ml-auto mr-3 px-3 py-2 badge bg-purple text-white float-md-right"
                            >Add/Edit Notes</a>                      
                                                      
                            </h5>
                        <hr>
                        <div class="row">
                            <div class="col-md-12">
                                <label class="text-grey"> Notes</label>
                                <p> {{appNotesDetails.note}}</p>
                            </div>  
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                <label class="text-grey">Created On</label>
                                <p> {{appNotesDetails.createdOn | date : 'MMM dd, yyyy HH:mm'}}</p>
                            </div>  
                        </div>
                    </div>
                </div>

                <!-- payment Details for this appointment -->
                <div class="col-12">
                    <div class="card">
                        <h5 class="mb-0 text-purple">Payment Details <span class="badge bg-warning float-right"
                                *ngIf="paymentStatus">Full Paid</span></h5>
                        <hr>
                        <div class="row">
                            <div class="col-md-4">
                                <label class="text-grey">Assessment Amount</label>
                                <p> ${{totalAmount}} </p>
                            </div>
                            <div class="col-md-4">
                                <label class="text-grey">Received Amount</label>

                                <p>${{paymentMade}}</p>
                            </div>

                            <div class="col-md-4">
                                <label class="text-grey">Amount Due</label>
                                <p class="text-danger">${{remainingAmount}}</p>
                            </div>

                        </div>

                    </div>
                </div>

                <!--  -->

                <div class="col-12" *ngIf='apptDetails'>
                    <div class="actions d-flex flex-wrap justify-content-center"
                        *ngIf='(userRole=="ADMIN" || userRole=="DIRECTOR") && (apptDetails.appointmentDetails.schedules[0].status!="CANCEL" || status!="FOLLOWUP") '>

                        <button
                            *ngIf='(userRole!="DIAGNOSTIC") && (apptDetails.appointmentDetails.schedules[0].status=="ASSESMENT") && (apptDetails.appointmentDetails.schedules[1].status=="FOLLOWUP") && (paymentStatus) && (!recieptSent)'
                            class="theme-button green m-2" (click)="openReciept()">
                            Send Receipt
                        </button>

                        <button
                            *ngIf='(userRole!="DIAGNOSTIC") &&  apptDetails.appointmentDetails.schedules[0].status=="COMPLETE" && paymentStatus && recieptSent'
                            class="theme-button green m-2" (click)="openReciept()">
                            View Receipt
                        </button>

                        <button
                            *ngIf='(!apptDetails.appointmentDetails.schedules[0].statusTracking.includes("REVIEWED") || apptDetails.appointmentDetails.schedules[0].status=="CREATED") && (apptDetails.appointmentDetails.schedules[0].status!="CANCEL")'
                            (click)="getSurveys()" class="theme-button m-2" data-toggle="modal"
                            data-target="#selectSurveys">
                            Test Plan
                        </button>

                        <button
                            *ngIf='(userRole=="ADMIN" || userRole=="DIRECTOR") && apptDetails.appointmentDetails.schedules[0].statusTracking.includes("REVIEWED")&&(apptDetails.appointmentDetails.schedules[0].status!="ASSESMENT" && apptDetails.appointmentDetails.schedules[0].status!="COMPLETE")'
                            (click)="getSurveys()" class="theme-button m-2" data-toggle="modal"
                            data-target="#selectSurveys">
                            Edit Test Plan
                        </button>

                        <button *ngIf='apptDetails.appointmentDetails.schedules[0].statusTracking.includes("REVIEWED")'
                            class="theme-button m-2" data-toggle="modal" data-target="#uploadModal">
                            Upload Documents
                        </button>
                        <!-- !paymentStatus && !recieptSent && payment condtion removed in phase 4  -->
                        <button *ngIf=' apptDetails.appointmentDetails.schedules[0].status!="CANCEL"'
                            class="theme-button green m-2" data-toggle="modal"  (click)="openPaymentModal()">
                            Payment
                        </button>

                        <button
                            *ngIf='(userRole=="ADMIN") &&( apptDetails.appointmentDetails.schedules[0].status!="CANCEL" && apptDetails.appointmentDetails.schedules[0].status!="COMPLETE" && apptDetails.appointmentDetails.schedules[0].status!="ASSESMENT")'
                            class="theme-button danger m-2"  (click)="openCancelApptModal()" >
                            Cancel Appointment
                        </button>
                        <button
                            *ngIf='(userRole=="ADMIN")&& (!apptDetails.appointmentDetails.hold) &&( apptDetails.appointmentDetails.schedules[0].status!="CANCEL" && apptDetails.appointmentDetails.schedules[0].status!="COMPLETE" && apptDetails.appointmentDetails.schedules[0].status!="ASSESMENT")'
                            class="theme-button m-2"  data-toggle="modal" data-target="#holdApptModal">
                            Hold Appointment
                        </button>
                        <button
                            *ngIf='(!followUpCreated) && (apptDetails.appointmentDetails.schedules[0].status!="ASSESMENT" || apptDetails.appointmentDetails.schedules[0].status!="COMPLETE") '
                            class="theme-button m-2" (click)="openFollowUpModal()">
                            Create Follow Up
                        </button>

                    </div>
                </div>
                <div class="col-12 mb-5"
                    *ngIf='userRole=="DIAGNOSTIC" &&  apptDetails.appointmentDetails.schedules[0].status=="REVIEWED"'>

                    <div class="actions d-flex justify-content-center">

                        <a *ngIf="(currentDate | date:'MMM dd, yyyy')==(apptDetails.appointmentDetails.schedules[0].appointmentDate | date:'MMM dd, yyyy') && !apptDetails.draftObservation"
                            class="theme-button"
                            [routerLink]="['/student-observation',apptDetails.appointmentDetails.appointmentId,false]">Start
                            Assessment</a>

                        <a *ngIf="apptDetails.draftObservation" class="theme-button"
                            [routerLink]="['/student-observation',apptDetails.appointmentDetails.appointmentId,true]">Complete
                            Assessment</a>
                    </div>
                </div>
            </div>
        </div>

    </div>

</div>
<div class="survey-modal modal fade" id="selectSurveys" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="selectSurveys" aria-hidden="true">
    <div class="modal-dialog">
        <div *ngIf="surveys" class="modal-content text-center light px-5 py-4">
            <form action="" id="selectSurveyForm" [ngClass]="{'pointer-disable'  : isApptCompleted==true}">
                <div class="tests mb-4">
                    <div class="row">
                        <div class="col-12 text-left mb-3">
                            <h6 class="text-purple">Please choose tests.</h6>
                        </div>
                        <div class="col-md-3" *ngFor="let test of surveys.testsList">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" [(ngModel)]="test.checked" name="{{'testCheckbox_' + test.id}}" (ngModelChange)="onChangeSurveys()" 
                                    class="custom-control-input">
                                <label class="custom-control-label">{{test.name}}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <hr>
                <div class="surveys mt-4 mb-3">
                    <div class="row">
                        <div class="col-12 text-left mb-3">
                            <h6 class="text-purple">Please choose surveys.</h6>
                        </div>
                        <div class="col-md-3" *ngFor="let survey of surveys.surveysList">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" [(ngModel)]="survey.checked" name="{{'surveyCheckbox_' + survey.id}}" (ngModelChange)="onChangeSurveys()" class="custom-control-input">
                                <label class="custom-control-label">{{survey.name}}</label>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col-12">
                            <textarea name="testSurveyComment" [(ngModel)]="testSurveyComment" (ngModelChange)="onChangeSurveys()" rows="1"
                                class="custom-input" placeholder="Other Comments"></textarea>
                        </div>
                    </div>
                </div>
                <div class="action">
                    <button type="submit" class="theme-button green mr-2"  [ngClass]="{'grey' : !validationTest()}"   [disabled]="!validationTest()"  data-dismiss="modal" (click)="addSurveys()"
                        >Save</button>
                    <a href="javascript:void(0)" class="theme-button grey"
                        [ngClass]="{'pointer-enable'  : isApptCompleted==true}" data-dismiss="modal">Close</a>
                </div>
            </form>
        </div>
    </div>
</div>


<!-- cancel appt modal -->

<div class="modal fade" id="cancelApptModal" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="cancelApptModal" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content light px-5 py-4">
            <h6 class="mb-4 text-center">Are you sure you want to cancel or reschedule this appointment?</h6>
            <!-- <p class="text-grey text-center">Choose reason for cancelling</p> -->
            <div class="border-bottom border-top d-flex justify-content-center mb-4 mt-3 p-3">
                <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" id="noShowAppt" name="cancelAppointmentReason" class="custom-control-input"
                        value="Cancel" [(ngModel)]="comments">
                    <label class="custom-control-label" for="noShowAppt">Cancel</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" id="rescheduleAppt" name="cancelAppointmentReason" class="custom-control-input"
                        value="Reschedule" [(ngModel)]="comments">
                    <label class="custom-control-label" for="rescheduleAppt">Requesting Reschedule</label>
                </div>
            </div>
            <!-- <textarea name="reasonCancellation" rows="3" [(ngModel)]="comments" placeholder="Reason for cancellation" class="custom-input mb-3"></textarea> -->
            <div class="action text-center">
                <button type="submit" *ngIf="!cancelAppt" (click)="CancelAppt()" 
                    class="theme-button danger mx-2"  [ngClass]="{'grey': !validationRadio()}" [disabled]="!validationRadio()">Yes</button>
                <a href="#!" class="theme-button grey mx-2" (click)="cancelAppt = false" data-dismiss="modal">Back</a>
            </div>
        </div>
    </div>
</div>


<!-- hold appt modal -->

<div class="modal fade" id="holdApptModal" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="holdApptModal" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content light px-5 py-4">
            <h6 class="mb-4 text-center">Are you sure you want to hold this appointment?</h6>
            <div class="action text-center">
                <button type="submit" (click)="HoldAndUnHoldAppt('HOLD')" data-dismiss="modal"
                    class="theme-button danger mx-2">Yes, Hold</button>
                <a href="#!" class="theme-button grey mx-2" data-dismiss="modal">Back</a>
            </div>
        </div>
    </div>
</div>


<!-- payment modal -->
<div class="modal fade" id="paymentModal" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="paymentModal" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content light px-5 py-4">
            <h4 class="text-center">Collect Payment</h4>
            <table class="mt-2 table-bordered small table-sm text-monospace">
                <tbody>
                    <tr>
                        <td>Test Amount</td>
                        <td>${{totalAmount}}</td>
                    </tr>
                    <tr>
                        <td>Collected Amount</td>
                        <td>${{paymentMade}}</td>
                    </tr>
                    <tr>
                        <td>Test Fee Adjustment</td>
                        <td>
                            <input type="text" [(ngModel)]="miscAdjustment" (input)="onInputRestrict($event)"
                            pattern="^-?\d*$" (ngModelChange)="handlePaymentChange()"
                                class="custom-input my-1">
                        </td>
                    </tr>
                    <tr>
                        <td>Collect Amount Adjustment</td>
                        <td>
                            <input type="text" [(ngModel)]="depositAdjustment" (input)="onInputRestrict($event)"
                            pattern="^-?\d*$" (ngModelChange)="handlePaymentChange()"
                                class="custom-input my-1">
                        </td>
                    </tr>

                    <tr class="text-danger">
                        <td>Balance Due</td>
                        <td>${{remainingAmount}}</td>
                    </tr>
                </tbody>
            </table>
            <input type="text" placeholder="Enter Amount" [(ngModel)]=paymentAmount  
                (ngModelChange)="handlePaymentChange()" id="bookingDeposit" class="custom-input my-4 textAmount" required  pattern="^-?\d*$">
                <small class="text-danger" *ngIf="isNumericPayment()" >
                    Only number allowed!
                </small>
                <!-- <div *ngIf="!isPaymentValid()" class="validation-message">
                    Invalid adjustment or amount. Ensure the total due is not negative and the entered amount does not
                    exceed the due balance.
                </div> -->

                
            <div class="action border-top pt-4 text-center">
                <a href="https://app.fluidpay.com/auth"
                    target="_blank" class="theme-button green mx-2">Payment Link</a>
                <button class="theme-button mx-2" [ngClass]="{'grey' : !isPaymentAmountValid()}"   [disabled]="!isPaymentAmountValid()" (click)="submitPayment()">Collect</button>
                
                <a href="#!" class="theme-button grey mx-2" data-dismiss="modal">Cancel</a>

            </div>
        </div>
    </div>
</div>

<!-- Reschedule Appointment Modal -->
<div class="modal fade" id="rescheduleAppointment" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="rescheduleAppointment" aria-hidden="true">
    <div class="modal-dialog" style="max-width: 700px;">
        <div class="modal-content light py-3 px-4">
            <h5 class="border-bottom mb-3 pb-3 text-center text-green">Reschedule Appointment</h5>

        </div>
    </div>
</div>

<!-- Edit editAssementType  Modal -->
<div class="modal fade" id="editAssementType" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="editAssementType" aria-hidden="true">
    <div class="modal-dialog" style="max-width: 400px;">
        <div class="modal-content light py-3 px-4">
            <h5 class="border-bottom mb-3 pb-3 text-center text-green">Change Assessment Type</h5>
            <form [formGroup]="updateAssementForm" id="editAssesmentForm" class="custom-form">
                <div class="row light">
                    <div class="col-12">
                        <label class="small">Assessment Type</label>
                        <select id="assesmentType" formControlName="assesmentType">
                            <option value="" selected disabled></option>
                            <option *ngFor="let i of changeAssesmentType" [ngValue]="i.id">
                                {{i.name}}
                            </option>
                        </select>
                    </div>


                </div>
                <div class="row mt-4">
                    <div class="col-12 d-flex justify-content-center">
                        <button type="button" form="intakeForm" class="theme-button mr-3"
                            [ngClass]="{'grey' :   updateAssementForm.invalid }"
                            [disabled]=" updateAssementForm.invalid" (click)="updateAssesmentType()">Update</button>

                        <a href="#!" class="theme-button grey" data-dismiss="modal">Don’t Save</a>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Add/Edit Notes modal -->
<div class="modal fade" id="addNotesModal" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="uploadModal" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content light px-5 py-4">
            <h4 class="text-center">Add Notes</h4>  

            <form [formGroup]="addNotesForm" id="editNotesForm" class="custom-form">
                <div class="row light">
                   
                    <div class="col-lg-12 col-md-12">
                        <label class="small">Notes</label>
                        <textarea   [(ngModel)]="notesCurrent" placeholder="Enter notes here" formControlName="note"  
                        [ngClass]="{'border border-danger': fNotes['note'].touched && fNotes['note'].errors }"></textarea>
                                       

                    </div>
                </div>

                <div class="row mt-4">
                    <div class="col-12 d-flex justify-content-center">
                        <button type="button" form="intakeForm" class="theme-button mr-3"
                            [ngClass]="{'grey' :   addNotesForm.invalid }"
                            [disabled]=" addNotesForm.invalid" (click)="addNotes()">Add/Update</button>

                        <a href="#!" class="theme-button grey" (click)="onCloseNotes()" data-dismiss="modal">Close</a>
                    </div>
                </div>
            </form>    
            
        </div>
    </div>
</div>

<!-- Edit Client Info Modal -->
<div class="modal fade" id="editClientInfo" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="editClientInfo" aria-hidden="true">
    <div class="modal-dialog" style="max-width: 700px;">
        <div class="modal-content light py-3 px-4">
            <h5 class="border-bottom mb-3 pb-3 text-center text-green">Edit Client Info</h5>
            <form [formGroup]="updateClient" id="editClientForm" class="custom-form">
                <div class="row light">
                    <div class="col-lg-4 col-md-6">
                        <label class="small">Client First Name</label>
                        <input type="text" formControlName="studentFirstName" [ngClass]="{'border border-danger': f['studentFirstName'].touched && f['studentFirstName'].errors }" />
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <label class="small">Client Last Name</label>
                        <input type="text" formControlName="studentLastName" [ngClass]="{'border border-danger': f['studentLastName'].touched && f['studentLastName'].errors }">
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <label class="small">Parent Name</label>
                        <input type="text" formControlName="parentName">
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <label class="small">Date of Birth</label>
                        <input type="date" formControlName="dateOfBirth" [ngClass]="{'border border-danger': f['dateOfBirth'].touched && f['dateOfBirth'].errors }">
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <label class="small">Phone Number</label>
                        <input type="text" formControlName="phoneNumber">
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <label class="small">Cell Number</label>
                        <p-inputMask mask="(999) 999-9999" placeholder="Cell Number" formControlName="cellNumber"
                            [ngClass]="{'border border-danger': f['cellNumber'].touched && f['cellNumber'].errors }"></p-inputMask>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <label class="small">Email</label>
                        <input type="text" formControlName="emailAddress" [ngClass]="{'border border-danger': f['emailAddress'].touched && f['emailAddress'].errors }">
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <label class="small">Secondary Email</label>
                        <input type="text" formControlName="secondaryEmailAddress">
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <label class="small">Grade</label>
                        <select id="schoolType" formControlName="grade" #grade (change)="onGradeChange(grade.value)">
                            <option value="" selected disabled>Grade</option>
                            <option value="Adult">Adult</option>
                            <option value="College">College</option>
                            <option value="Kindergarten">Kindergarten</option>
                            <option value="Grade 1">Grade 1</option>
                            <option value="Grade 2">Grade 2</option>
                            <option value="Grade 3">Grade 3</option>
                            <option value="Grade 4">Grade 4</option>
                            <option value="Grade 5">Grade 5</option>
                            <option value="Grade 6">Grade 6</option>
                            <option value="Grade 7">Grade 7</option>
                            <option value="Grade 8">Grade 8</option>
                            <option value="Grade 9">Grade 9</option>
                            <option value="Grade 10">Grade 10</option>
                            <option value="Grade 11">Grade 11</option>
                            <option value="Grade 12">Grade 12</option>
                        </select>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <label class="small">School Type</label>
                        <select id="schoolType" formControlName="schoolType">
                            <option value="" selected disabled>School Type</option>
                            <option *ngFor="let i of schoolType">{{i.name}}</option>
                        </select>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <label class="small">School/District</label>
                        <input type="text" formControlName="school">
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <label class="small">Reason For Call</label>
                        <select id="reasonForCall" formControlName="reasonForCall">
                            <option value="" selected disabled>Reason For Call</option>
                            <option>ADHD/Attention</option>
                            <option>Math</option>
                            <option>Reading Comprehension</option>
                            <option>Dyslexia</option>
                            <option>Processing Issues</option>
                            <option>Writing</option>
                            <option>Dyscalculia</option>
                            <option>Dysgraphia</option>
                            <option>Other</option>
                        </select>
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <label class="small">Address1</label>
                        <input type="text" formControlName="address1">
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <label class="small">Address2</label>
                        <input type="text" formControlName="address2">
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <label class="small">City</label>
                        <input type="text" formControlName="city">
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <label class="small">State</label>
                        <input type="text" formControlName="state">
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <label class="small">Zip Code</label>
                        <input type="text" formControlName="zipCode">
                    </div>
                    <div class="col-lg-4 col-md-6">
                        <label class="small">Additional Comments</label>
                        <input type="text" formControlName="appointmentComments">
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-12 d-flex justify-content-center">
                        <!-- <a (click)="onClickSubmit()" class="theme-button mr-3 ">Update</a> -->
                        <button type="button" form="intakeForm" class="theme-button mr-3"
                            id="intakeFormSubmit" (click)="onClickSubmit()"
                            [ngClass]="{'grey' :updateClient.invalid }"
                            [disabled]=" updateClient.invalid"
                            >Update</button>

                        <a href="#!" class="theme-button grey" data-dismiss="modal">Don’t Save</a>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Upload modal -->
<div class="modal fade" id="uploadModal" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="uploadModal" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content light px-5 py-4">
            <h4 class="text-center">Upload Documents</h4>

            <input type="file" #documentInput (change)="selectFile($event)" placeholder="select document to be uploaded"
                id="document" class="custom-input my-4" required accept=".pdf, .doc, .docx">

            <div class="action border-top pt-4 text-center">
                <button class="theme-button mx-2" data-dismiss="modal" [disabled]="!selectedFiles"
                    [ngClass]="{'grey' :!selectedFiles}" (click)="upload()">Upload</button>
                <!-- <a href="#!" class="theme-button grey mx-2" data-dismiss="modal">Cancel</a> -->
                <button [disabled]="progress>0" class="theme-button grey mx-2" data-dismiss="modal" (click)="resetFileInput()">Cancel</button>
            </div>
            <!-- progress -->
            <div *ngIf="currentFile" class="progress my-3">

                <div class="progress-bar progress-bar-info progress-bar-striped" role="progressbar"
                    attr.aria-valuenow="{{ progress }}" aria-valuemin="0" aria-valuemax="100"
                    [ngStyle]="{ width: progress + '%' }">
                    {{ progress }}%
                </div>
            </div>
        </div>
    </div>
</div>





<div class="modal fade" id="docUploaded" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="docUploaded" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content light px-5 py-4">
            <div class="d-flex">
                <div class="icon">
                    <img src="assets/images/logo-icon-tick.svg" width="100" class="img-fluid mr-5">
                </div>
                <div class="content">
                    <h5>Document Uploaded Successfully!!</h5>
                    <a class="theme-button grey" (click)="pageReload()" data-dismiss="modal">Close</a>
                </div>
            </div>
        </div>
    </div>
</div>


<div *ngIf="show && paymentSubmitted" class="modal fade" id="appointmentScheduled" data-backdrop="static"
    data-keyboard="false" tabindex="-1" aria-labelledby="appointmentScheduled" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content light px-5 py-4">
            <div class="d-flex">
                <div class="icon">
                    <img src="assets/images/logo-icon-tick.svg" width="100" class="img-fluid mr-5">
                </div>
                <div class="content">
                    <h4>Payment Received!!</h4>
                    <p>Transaction Id: <span>{{paymentDetailsResponse.transactionId}}</span></p>
                    <a class="theme-button grey" (click)="pageReload()" data-dismiss="modal">Close</a>
                </div>
            </div>
        </div>
    </div>
</div>


<div *ngIf="viewReciept" class="modal fade" id="recieptModal" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="recieptModal" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content light px-5 py-4">
            <!-- <app-reciept [clientName]="appts.studentFirstName" [location]="locationName"
                [apptDate]="apptDetails.appointmentDetails.schedules[0].appointmentDate"
                [testType]="apptDetails.appointmentDetails.assesmentType" [totalAmount]="totalAmount"
                [paidAmount]="paymentMade"></app-reciept> -->

            <!-- table -->


            <h4 *ngIf="!recieptSent " class="text-center">Generate Receipt</h4>
            <h4 *ngIf="recieptSent " class="text-center">View Receipt</h4>

            <table class="my-4 small table-bordered table-sm w-100">
                <tbody>
                    <tr>
                        <td class="text-black-50">Client Name</td>
                        <td colspan="2">{{appts.studentFirstName}} {{appts.studentLastName}}</td>
                    </tr>
                    <tr>
                        <td class="text-black-50">Type of Evaluation</td>
                        <td colspan="2" *ngIf="!recieptSent"> <select (change)="selectedtypeOfEvaluation($event)">
                                <option value="" disabled selected>Type of Evaluation</option>

                                <option value="Psycho-Educational Evaluation"> Psycho-Educational Evaluation </option>
                                <option value="Dysgraphia"> Dysgraphia </option>
                                <option value="ADHD Evaluation"> ADHD Evaluation </option>
                                <option value="ADHD Evaluation"> Partial Assessment </option>

                            </select></td>
                        <td colspan="2" *ngIf="recieptSent">
                            {{viewRecieptDetials.assesmentType}}
                        </td>
                        <!-- <td colspan="2">{{apptDetails.appointmentDetails.assesmentType}}</td> -->
                    </tr>
                    <tr>
                        <td class="text-black-50">Date of Service</td>
                        <td colspan="2">{{apptDetails.appointmentDetails.schedules[0].appointmentDate}}</td>
                    </tr>

                    <tr>
                        <td class="text-black-50">Location</td>
                        <td colspan="2">{{locationName}}</td>
                    </tr>
                    <tr>
                        <td class="text-black-50">Primary Provider</td>
                        <td colspan="2">{{primaryProvider}}</td>
                    </tr>
                    <tr>
                        <td class="text-black-50">Secondary Provider</td>
                        <td colspan="2" *ngIf="!recieptSent"> <select (change)="selectedSecandarProvider($event)">
                                <option>Select Secondary Provider</option>

                                <option *ngFor="let diagnosis of UserDaigAdmin"
                                    value="{{diagnosis.firstName}} {{diagnosis.lastName}}"> {{diagnosis.firstName}}
                                    {{diagnosis.lastName}}
                                </option>

                            </select></td>
                        <td colspan="2" *ngIf="recieptSent">
                            {{viewRecieptDetials.secondaryProvider}}
                        </td>
                    </tr>
                    <tr>
                        <td class="text-black-50">Primary Diagnosis</td>
                        <td colspan="2" *ngIf="!recieptSent">
                            <select (change)="selectedPrimaryDiagnosis($event)">
                                <option>Select Primary Diagnosis</option>

                                <option *ngFor="let diagnosis of diagnosisList" value={{diagnosis}}> {{diagnosis}}
                                </option>

                            </select>
                        </td>

                        <td colspan="2" *ngIf="recieptSent">
                            {{viewRecieptDetials.PrimaryDiagnosis}}
                        </td>
                    </tr>
                    <tr>
                        <td class="text-black-50">Secondary Diagnosis</td>
                        <td colspan="2" *ngIf="!recieptSent">
                            <select (change)="selectedSecondaryDiagnosis($event)">
                                <option>Select Secondary Diagnosis</option>

                                <option *ngFor="let diagnosis of diagnosisList" value={{diagnosis}}> {{diagnosis}}
                                </option>
                                <option value="NA">NA</option>

                            </select>
                        </td>

                        <td colspan="2" *ngIf="recieptSent">
                            {{viewRecieptDetials.SecondaryDiagnosis}}
                        </td>
                    </tr>
                    <tr>
                        <td class="text-black-50">Tertiary Diagnosis</td>
                        <td colspan="2" *ngIf="!recieptSent">
                            <select (change)="selectedDiagnosis($event)">
                                <option>Select Tertiary Diagnosis</option>

                                <option *ngFor="let diagnosis of diagnosisList" value={{diagnosis}}> {{diagnosis}}
                                </option>
                                <option value="NA">NA</option>

                            </select>
                        </td>

                        <td colspan="2" *ngIf="recieptSent">
                            {{viewRecieptDetials.SecondaryDiagnosis}}
                        </td>
                    </tr>
                    <tr>
                        <td class="text-black-50">Assessment Amount</td>
                        <td colspan="2">
                            ${{totalAmount}}
                        </td>
                    </tr>
                    <tr>
                        <td class="text-black-50">Received Amount</td>
                        <td colspan="2">${{paymentMade}}</td>
                    </tr>
                    <tr>
                        <td colspan="3" align="center"><b>Units @ Fee Per Units</b></td>
                    </tr>
                    <tr>
                        <td>CPT codes</td>
                        <td>1 Unit= 30 Minutes
                        <td>Amount</td>
                    </tr>
                    <tr>
                        <td>96130</td>
                        <td><input type="number" [(ngModel)]="Unit96130" /> &nbsp; Units</td>
                        <td><span class="addon">$</span><input type="number" [(ngModel)]="Amount96130" /></td>
                    </tr>
                    <tr>
                        <td>96131</td>
                        <td><input type="number" [(ngModel)]="Unit96131" /> &nbsp; Units</td>
                        <td><span class="addon">$</span><input type="number" [(ngModel)]="Amount96131" /></td>
                    </tr>
                    <tr>
                        <td>96138</td>
                        <td><input type="number" [(ngModel)]="Unit96138" /> &nbsp; Units</td>
                        <td><span class="addon">$</span><input type="number" [(ngModel)]="Amount96138" /></td>
                    </tr>
                    <tr>
                        <td>96139</td>
                        <td><input type="number" [(ngModel)]="Unit96139" /> &nbsp; Units</td>
                        <td><span class="addon">$</span><input type="number" [(ngModel)]="Amount96139" /></td>
                    </tr>
                </tbody>
            </table>


            <div class="action text-center">
                <button *ngIf="!recieptSent" (click)="sendReciept()" class="theme-button mx-2"
                    [disabled]="primaryDiagnosis=='' || secondaryDiagnosis==''"
                    [ngClass]="{'grey' :primaryDiagnosis=='' || secondaryDiagnosis=='' }" data-dismiss="modal"
                    data-toggle="modal" data-target="#receipt">Send
                    Receipt</button>
                <a href="#!" class="theme-button grey mx-2" data-dismiss="modal">Close</a>
            </div>
        </div>
    </div>
</div>



<div class="modal fade" id="receipt" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="receipt" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content light px-5 py-4">
            <div class="d-flex">
                <div class="icon">
                    <img src="assets/images/logo-icon-tick.svg" width="100" class="img-fluid mr-5">
                </div>
                <div class="content">
                    <h4>Receipt Sent Successfully!!</h4>
                    <!-- <p>Reciept Id: <span>47346201</span></p> -->

                    <!-- <a class="theme-button grey" data-dismiss="modal">Home</a> -->
                </div>
            </div>
        </div>
    </div>
</div>



<!-- calendar Modal -->

<div class="modal fade" [class.show]="isModalOpen" [attr.aria-hidden]="!isModalOpen ? 'true' : null" id="followUpModal"
    #followUpModal data-keyboard="false" data-backdrop="static" tabindex="-1" aria-labelledby="followUpModal" style="display: none;"
    [ngStyle]="{'display': isModalOpen ? 'block' : 'none'}">
    aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">

            <div class="actions">
                <!-- Reset/Close Button in Modal -->
                <button type="button" class="theme-button grey float-right" (click)="onDeleteClick()">
                    {{ reset }}
                </button>
                <a *ngIf="directorAvailable" href="javascript:void()" class="theme-button green float-right mr-2"
                    (click)="getAdminName()" data-toggle="modal" data-dismiss="modal">Save</a>
            </div>

            <div class="scheduler mt-2" *ngIf="show">
                <div class="card">
                    <div *ngIf="directorAvailable">
                        <mbsc-eventcalendar [clickToCreate]="clickToCreate" [view]="view" [invalid]="invalid"
                            [data]="myEvents" [options]="calendarOptions" [resources]="myResources"
                            [resourceTemplate]="resourceTemp">
                            <ng-template #resourceTemp let-resource>
                                <div class="header-resource-template-content">
                                    <!-- <img class="header-resource-avatar mb-2" [src]="resource.img" [width]="50" /> -->
                                    <div class="header-resource-name">{{resource.name}}</div>
                                </div>
                            </ng-template>
                        </mbsc-eventcalendar>
                        <!--  -->
                        <mbsc-popup [options]="popupOptions" [anchor]="popupAnchor" [buttons]="popupButtons"
                            [headerText]="popupHeaderText" #popup>
                            <div class="mbsc-form-group">
                                <mbsc-input label="Title" [(ngModel)]="popupEventTitle"></mbsc-input>
                                <mbsc-input label="Location" [(ngModel)]="locationName"></mbsc-input>

                            </div>
                            <div class="mbsc-form-group">
                                <!-- <mbsc-input [disabled]="true" label="Select Time Slot" labelStyle="floating">
                                </mbsc-input>
                                <mbsc-datepicker [(ngModel)]="popupEventDates" [options]="datePickerOptions"
                                    [controls]="datetimePickerControls" >
                                </mbsc-datepicker> -->

                                <!-- <mbsc-input #startInput label="Starts"></mbsc-input>
                                <mbsc-input #endInput label="Ends"></mbsc-input> -->

                                <div *ngIf="isEdit" class="mbsc-button-group">
                                    <mbsc-button class="mbsc-button-block" color="danger" variant="outline"
                                        (click)="onDeleteClick()">Delete event
                                    </mbsc-button>
                                </div>
                            </div>
                        </mbsc-popup>
                    </div>
                    <div *ngIf="!directorAvailable" style="    height: 100px;
                    text-align: center;
                    font-style: normal;
                    font-size: 25px;">
                        No Director for this location
                    </div>
                </div>
            </div>


        </div>
    </div>
</div>

<!-- calender Modal -->

<!-- Follow up Confirmation Modal -->
<div class="modal fade" *ngIf="show && apptDetails" id="followupConfirmationModal" data-backdrop="static"
    data-keyboard="false" tabindex="-1" aria-labelledby="followupConfirmationModal" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content light px-5 py-4">
            <div class="d-flex mx-auto">
                <div class="content">
                    <h4 class="text-center">Please confirm details</h4>
                    <ul>
                        <li><span>Client Name</span>: {{apptDetails.parentDetails.studentFirstName}}
                            {{apptDetails.parentDetails.studentLastName}}</li>
                        <li><span>Assigned To</span>: {{assignedAdmin}}
                        </li>
                        <li><span>Location</span>: {{locationName}}</li>
                        <li><span>Follow Up Date</span>: {{assessmentDate}}</li>
                        <li><span>Follow Up Time</span>: {{appointmentTime}} </li>

                    </ul>
                    <hr />
                    <div class="custom-control custom-checkbox text-center">
                        <input type="checkbox" [checked]="inPersonZoomFollowUp"
                            (change)="inPersonZoomFollowUp = !inPersonZoomFollowUp" class="custom-control-input">
                        <label class="custom-control-label">Online Follow Up (Zoom)</label>
                    </div>
                    <hr />
                    <a (click)="CreateFollowUp()" class="theme-button mr-3" data-toggle="modal"
                        data-dismiss="modal">Confirm</a>
                    <a class="theme-button grey" data-dismiss="modal" data-toggle="modal"
                        data-target="#followUpModal">Change</a>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- 
<input type="checkbox" [checked]="survey.checked"
                                    (change)="survey.checked = !survey.checked" class="custom-control-input">
                                <label class="custom-control-label">{{survey.name}}</label> -->

<div class="modal fade" id="viewDocumentsModal" data-keyboard="true" tabindex="-1" aria-labelledby="viewDocumentsModal"
    aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content light px-5 py-4">
            <div class="d-flex justify-content-end">
                <!-- Close button or icon -->
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <h5 class="text-center mb-4">Attached Documents</h5>
            <div class="d-flex flex-wrap justify-content-center">
                <p class="badge bg-theme-light border mr-2" *ngFor="let doc of documents">
            
                        <a [href]="appBaseUrl + doc.filePath"
                           download="{{doc.fileName}}"
                           target="_blank" 
                           class="d-flex px-3 py-2 small text-dark text-left text-wrap">{{doc.fileName}} <span class="align-items-center badge badge-warning d-flex ml-3">&#10515; Download</span></a>
                      </p>
                      
            </div>
        </div>
    </div>
</div>
<!-- Follow up scheduled Modal -->
<div *ngIf="show && apptDetails" class="modal fade" id="followupScheduledModal" data-backdrop="static"
    data-keyboard="false" tabindex="-1" aria-labelledby="followupScheduledModal" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content light px-5 py-4">
            <div class="d-flex">
                <div class="icon">
                    <img src="assets/images/logo-icon-tick.svg" width="100" class="img-fluid mr-5">
                </div>
                <div class="content">
                    <h4>Follow Up Scheduled!!</h4>
                    <ul>
                        <li><span>Client Name</span>: {{apptDetails.parentDetails.studentFirstName}}
                            {{apptDetails.parentDetails.studentLastName}}</li>
                        <li><span>Assigned To</span>: {{assignedAdmin}}
                        </li>
                        <li><span>Location</span>: {{locationName}}</li>
                        <li><span>Follow Up Date</span>: {{assessmentDate}}</li>
                        <li><span>Follow Up Time</span>: {{appointmentTime}} </li>
                        <li *ngIf="inPersonZoomFollowUp" ><span>Follow Up Type</span>: Online Follow Up (Zoom) </li>
                        <li *ngIf="!inPersonZoomFollowUp" ><span>Follow Up Type</span>: In-Person </li>
                    </ul>

                    <a class="theme-button grey" onclick="window.location.reload();" data-dismiss="modal">Back</a>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal fade" id="errorModal" data-backdrop="static" data-keyboard="false" tabindex="-1"
    aria-labelledby="errorModal" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content light px-5 py-4">
            <h6 class="mb-4 text-center">Something wrong, please try again !</h6>
            <!-- <div class="action text-center">
        <button type="submit" (click)="submit()" class="theme-button green mx-2" data-dismiss="modal">Yes,
          Continue</button>
        <a href="#!" class="theme-button grey mx-2" data-dismiss="modal">No</a>
      </div> -->
        </div>
    </div>
</div>

<div>
</div>
<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-scale-multiple"></ngx-spinner>
